/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * @param {UniversalAnalytics.FieldsObject} params
 * @returns {void}
 */
const sendGaEvent = (params: UniversalAnalytics.FieldsObject): void => {
    if (window && (window as any).ga) {
        (window as any).ga('send', 'event', params);
    }
};

export default sendGaEvent;
